module.exports = __webpack_public_path__ + "img/motorbikeOverview2.e1470d5c.svg";